export const AGORA_APP_ID = '7bebf7854f604dbf818e4ad1b78ddebc';
